import { useStaticQuery, graphql } from "gatsby"
import { Link, isSold } from "@StarberryUtils";
import React, { useState, useEffect } from "react"
import { Button, Form, Carousel, Container, Row, Col, Fade } from 'react-bootstrap';
import PropertyIMG1 from "../../../images/search-result/property-img.jpg";
import FsLightbox from 'fslightbox-react';
import _ from "lodash";
import { SaveItem, useUserObjectState, useAuthState } from "@starberry/myaccount-website-utils";
// import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
// Style
import './ProductBanner.scss';
import PlayVideo from "../../Play/CustomVideo";
import ModalTiny from "react-bootstrap/Modal"
import BookViewingForm from "../../Forms/book-a-viewing-form";
import PropertyReportForm from "../../Forms/property-report-form";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share";


import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon
} from "react-share";

import { inViewOptions, containerVariants, fadeInFromBottom, contentItemStagger, contentItem } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import AllOffice from "../../../hooks/useOffice"

const ProductBanner = (props) => {
  const team = useStaticQuery(graphql`
  query peopleQuery{
    glstrapi {
      teams(sort:"createdAt:asc", where:{Publish:true}) {
        id
        Name
        Tile_Image {
          url
          alternativeText
        }
        URL
        Designation
        offices{
          Name
        }
        Email
        Phone
        NegotiatorId
      }
    }
  }
`)

  const { state, services } = useUserObjectState()
  const { services: authServices } = useAuthState()
  const isAuthenticated = authServices.isAuthenticated()

  useEffect(() => {
    if (isAuthenticated) {
    // on page load get the users saved objects
        services.getUserobject({ type: "property", state:true })
    }
  }, [])

  const teams = team.glstrapi?.teams;


  const [propertyImg, setPropertyImg] = useState(process.env.GATSBY_SITE_URL + '/images/property-image.jpg');
  const [allPropertyImg, setAllPropertyImg] = useState([]);
  const [isPlaying, setPlaying] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [floorToggler, setFloorToggler] = useState(false);
  const shareurl = typeof window !== 'undefined' ? window.location.href : ''
  const [Shareicons, setShareicons] = React.useState(false);
  const [index, setIndex] = useState(0);
  const [index2, setIndex2] = useState(0);
  const openShareicons = () => {
    setShareicons(true);
  }

  const closeShareicons = () => {
    setShareicons(false);
  }
  const handleSelect = (selectedIndex, e) => {
    setIndex2(selectedIndex);
  };

  const [modalValuationformOpen, setValuationformOpen] = React.useState(false);
  const closeValuationformModal = () => {
    setValuationformOpen(false);
  }
  const openValuationformModal = () => {
    setValuationformOpen(true);
  }

  const [modalPropertyReportformOpen, setPropertyReportformOpen] = React.useState(false);
  const closePropertyReportformModal = () => {
    setPropertyReportformOpen(false);
  }
  const openPropertyReportformModal = () => {
    setPropertyReportformOpen(true);
  }

  const trackerShare = (event) => {
    var shareURL = typeof window !== 'undefined' ? window.location.href : ''
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Share - social icons',
      'formType': event + ' - ' + shareURL,
      'formId': 'Share',
      'formName': 'Share',
      'formLabel': 'Share', 
      'formPage' : shareURL
    });
  }

  const TeamDetails = (props) => {


    var result = _.find(teams, function (o) { return (o.NegotiatorId === props.negotiatorId); });
    const officeName = (item) => {
      if (_.toLower(item.Designation) === "branch manager" || _.toLower(item.Designation) === "area manager") {
        return _.join(_.map(item.offices, 'Name'), ' & ');
      }
    }
    if (!_.isEmpty(result)) {
      return (
        <div className="contact-agent">
          <div className="contact-agent-photo">
            {result.Tile_Image &&
              <img src={result.Tile_Image.url} alt={result.Tile_Image.alternativeText} />
            }
          </div>
          <div className="contact-agent-info">
            <span className="contact-agent-name"> {result.Name}</span>
            <span className="agent-designation "> {officeName(result)} {result.Designation}</span>
            <a
              href={`tel:+44${result.Phone}`}
              className="contact-agent-number"
            >
              {result.Phone}
            </a>
          </div>

        </div>
      )
    } else {
      return null;
    }
  }

  const formatter = (val) => {
    if (val) {

      return "£" + new Intl.NumberFormat("en-US", {}).format(val);
    } else {
      return "£0"
    }
  }

  const priceTag = (val) => {
    if (!_.isEmpty(val)) {
      return _.startCase(val.split(/(?=[A-Z])/).join(' '));
    } else {
      return ""
    }
  }

  const getAuctionTag = (val) => {
    var value = "";
    if (!_.isEmpty(val)) {
      if (!_.isEmpty(val.disposal) && _.toLower(val.disposal) == "auction") {
        value  = _.capitalize(val.disposal);
      } 
    }
    return value;

  } 

  useEffect(() => {
    if (props.data.images && props.data.images.length != 0) {
      setPropertyImg(props.data.images[0].url);
      if (_.isEmpty(allPropertyImg)) {
        props.data.images.map((img) => {
          if (!_.isEmpty(img.url)) {
            allPropertyImg.push(img.url);
            setAllPropertyImg(allPropertyImg)
          }

        })
      }
    }
  }, []); 
  return (
    <React.Fragment>
      {props.data &&
        <>
          <InView {...inViewOptions}>
            {({ ref, inView }) => (
              <motion.div
                className="product-banner property-banner"
                ref={ref}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                variants={containerVariants}
              >
                <div className="banner-wrap">
                  <Container>
                    <Row>
                      <Col lg="5" className="order-md-2 img-zoom pr-0 pl-0">

                        <motion.div className="banner-section-img" variants={fadeInFromBottom}>
                          {
                            allPropertyImg && allPropertyImg != 0 ?
                              <Carousel onSelect={handleSelect}>
                                {allPropertyImg && allPropertyImg.map((img, i) => {
                                  return (
                                    <Carousel.Item key={i} className="" id={"prop-img" + i}>
                                      <picture>
                                        <img src={img} alt={`${props.data.display_address} - DB Roberts`} />
                                      </picture>
                                    </Carousel.Item>
                                  )
                                }
                                )}
                              </Carousel>
                              :
                              <picture>
                                <img src={PropertyIMG1} alt={`${props.data.display_address} - DB Roberts`} />
                              </picture>

                          }
                          <div className="property-btns">
                            {
                              allPropertyImg && allPropertyImg.length > 0 &&
                              <Button type="button" variant="link" className="zoom-btn" onClick={() => setToggler(!toggler)}>
                                <i className="icon-zoom"></i> <span className="img-count">{index2+1}/{allPropertyImg.length}</span>
                              </Button>

                            }
                            {props.data.virtual_tour && props.data.virtual_tour.length > 0 &&
                              <PlayVideo url={props.data.virtual_tour[0].url} type={`button`} buttonName={`Video tour`} icon="icon-video" class="play-btn" fullscreen />
                            }
                            {
                              props.data.floorplan && props.data.floorplan.length > 0 &&
                              <Button type="button" variant="link" className="flor-btn" onClick={() => setFloorToggler(!floorToggler)}>
                                <i className="icon-floorplan"></i> Floorplan
                              </Button>
                            }
                            {isSold(props.data.status) &&
                              <Button
                                type="button"
                                variant="link"
                                className="photos_box flor-btn sold-box"
                              >
                                {props.data.status == "Sold" ? "Sold STC" : props.data.status}
                              </Button>
                            }
                            {(!_.isEmpty(getAuctionTag(props.data?.extra))) &&
                              <Button
                                type="button"
                                variant="link"
                                className="photos_box flor-btn auction-box"
                              >
                                {getAuctionTag(props.data.extra)}
                              </Button>
                            }
                          </div>
                        </motion.div>

                      </Col>
                      <Col lg="7" xl="5" className="order-md-1">
                        <motion.div variants={contentItemStagger}>
                          <div className="banner-section-content">
                            <motion.h1 variants={contentItem}>{_.startCase(_.toLower(props.data.title).replace(/-/g, " ")).replace(/In/g, "in")} in {props.data.display_address}</motion.h1>
                            <motion.div className="price-block" variants={contentItem}>
                              <span>{priceTag(props.data.price_qualifier)} {formatter(props.data.price)} {props.data.search_type === "lettings" ? "Per Calendar Month" : ""}</span>
                            </motion.div>
                            <motion.div className="property-overview" variants={contentItem}>
                              <ul className="d-flex">
                                {(props.data.bedroom != null && props.data.bedroom != "" && props.data.bedroom != "0") &&
                                  <li><i className="icon-bedroom"></i> {props.data.bedroom}<span>  Bedrooms</span></li>
                                }
                                {(props.data.bathroom != null && props.data.bathroom != "" && props.data.bathroom != "0") &&
                                  <li><i className="icon-bathroom"></i>  {props.data.bathroom}<span> Bathroom</span></li>
                                }
                                {(props.data.reception != null && props.data.reception != "" && props.data.reception != "0") &&
                                  <li><i className="icon-reception"></i>  {props.data.reception}<span> Reception</span></li>

                                }


                              </ul>
                              </motion.div>
                              <div className="banner-section-btn details_page">
                                <a href="javascript:void(0)" onClick={() => { openValuationformModal() }} className="btn btn-primary d-none d-md-flex">Arrange a viewing <i className="icon-arrow mt-1"></i></a>
                                {(props.data.extra.report_download && props.data.extra.report_download!= null) &&
                                  <a href="javascript:void(0)" onClick={() => { openPropertyReportformModal() }} className="btn btn-primary d-md-flex report-download">Download Property Report</a>
                                }
                              </div>
                            <div class="negotiator-block">
                            <div class="negotiator-details col-lg-6 order-md-1">
                            {
                              props.data.crm_negotiator_id &&
                              <motion.div variants={contentItem}>
                                <TeamDetails negotiatorId={props.data.crm_negotiator_id} />
                              </motion.div>
                            }
                            </div>
                              <div class="share-heart-icon banner-section-btn col-lg-6 order-md-2">
                                <div className="d-none d-sm-none d-md-none d-lg-block">
                                  <a href="javascript:void(0)" onClick={() => setShareicons(!Shareicons)} className="btn-circle position-relative"> <i className="icon-share"></i>
                                    {Shareicons &&
                                      <div className="property-share-social-icons">
                                        <FacebookShareButton onClick={() => trackerShare('FacebookShareButton')} url={shareurl} className="my-share-button facebook-share">
                                          <FacebookIcon size={32} round={false} borderRadius={`10`} />
                                        </FacebookShareButton>
                                        <TwitterShareButton onClick={() => trackerShare('TwitterShareButton')} url={shareurl} className="my-share-button twitter-share">
                                          <TwitterIcon size={32} round={false} borderRadius={`10`} />
                                        </TwitterShareButton>
                                        <LinkedinShareButton onClick={() => trackerShare('LinkedinShareButton')} url={shareurl} className="my-share-button linkedin-share">
                                          <LinkedinIcon size={32} round={false} borderRadius={`10`} />
                                        </LinkedinShareButton>
                                        <WhatsappShareButton onClick={() => trackerShare('WhatsappShareButton')} url={shareurl} className="my-share-button whatsapp-share">
                                          <WhatsappIcon size={32} round={false} borderRadius={`10`} />
                                        </WhatsappShareButton>
                                      </div>
                                    }
                                  </a>
                                </div>
                                {!isSold(props.data.status) &&
                                    <SaveItem type="property" pid={props.data.id}>
                                      <span className="btn-circle position-relative">
                                        <i class="icon-like mt-1 icon-default"></i>
                                        <i class="icon-like-white-fill mt-1 icon-saved"></i>
                                      </span>
                                    </SaveItem>
                                }
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </motion.div>
            )}
          </InView>
          {!_.isEmpty(allPropertyImg) &&
            <FsLightbox
              toggler={toggler}
              sources={allPropertyImg}
              type='image'
            />
          }

          <FsLightbox
            toggler={floorToggler}
            sources={props.data.floorplan.map(img => img.url)}
            type='image'

          />
          <ModalTiny size="lg" show={modalValuationformOpen} onHide={closeValuationformModal} className="modal-form">
            <ModalTiny.Header closeButton className="contact-close-btn">
              <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Arrange a Viewing</h2></ModalTiny.Title>
            </ModalTiny.Header>
            <ModalTiny.Body className="event-section">
              <BookViewingForm
                title="Arrange a Viewing"
                type="Sales"
                property_img={propertyImg}
                property_id={props.data && props.data.id ? props.data.id : ''}
                property_crm_id={props.data && props.data.crm_id ? props.data.crm_id : ''}
                page_url={ shareurl}
                property_title={props.data && props.data.display_address ? props.data.display_address : ''}
                property_display_address={props.data && props.data.display_address ? props.data.display_address : ''}
                address={props.data && props.data.address ? props.data.address : ''}
                to_email={props.data && props.data.office_crm_id ? AllOffice(props.data.office_crm_id) : ''}
                search_type={props.data.search_type ? props.data.search_type : '' }
              />
            </ModalTiny.Body>
          </ModalTiny>
          <ModalTiny size="lg" show={modalPropertyReportformOpen} onHide={closePropertyReportformModal} className="modal-form">
            <ModalTiny.Header closeButton className="contact-close-btn">
              <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Property Report Download</h2></ModalTiny.Title>
            </ModalTiny.Header>
            <ModalTiny.Body className="event-section">
              <PropertyReportForm
                title="Property Report Download"
                type="Sales"
                property_img={propertyImg}
                property_id={props.data && props.data.id ? props.data.id : ''}
                page_url={ shareurl}
                property_title={props.data && props.data.display_address ? props.data.display_address : ''}
                property_report_download={props.data.extra.report_download && props.data.extra.report_download!= null ? props.data.extra.report_download : ''}
                property_display_address={props.data && props.data.display_address ? props.data.display_address : ''}
                address={props.data && props.data.address ? props.data.address : ''}
              />
            </ModalTiny.Body>
          </ModalTiny>
        </>
      }
    </React.Fragment>

  )
}



export default ProductBanner